"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lock = _interopRequireDefault(require("cccisd-icons/lock4"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Tab = function Tab(_ref) {
  var currTab = _ref.currTab,
    mediatorProps = _ref.mediatorProps,
    onClickTab = _ref.onClickTab,
    tabKey = _ref.tabKey;
  var locked = false;
  if (!mediatorProps[tabKey]) {
    tabKey = tabKey.replace(/_locked$/, '');
    if (!mediatorProps[tabKey]) {
      return null;
    }
    locked = true;
  }
  if (!mediatorProps[tabKey].toggle && !mediatorProps[tabKey].isExternalRegistration) {
    return null;
  }
  return /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary ".concat(currTab === tabKey ? 'active' : ''),
    onClick: function onClick() {
      if (!locked) {
        onClickTab(tabKey);
      }
    },
    disabled: locked
  }, mediatorProps[tabKey].tabName, locked ? /*#__PURE__*/_react["default"].createElement("span", null, "\xA0\xA0", /*#__PURE__*/_react["default"].createElement(_lock["default"], null)) : null);
};
var _default = exports["default"] = Tab;